import OktaAuth from "@okta/okta-auth-js";
import { getConfig } from "../config";

export function getOktaAccessToken (okta?: OktaAuth): string|undefined {
  return process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_OKTA_TOKEN as string)
    : okta?.getAccessToken();
}

export function getBearerToken (okta?: OktaAuth): string {
  return `Bearer ${getOktaAccessToken(okta)}`;
}

export function avatarImageUrl(avatarImageId: string) {
  return `${getConfig().apiBaseUrl}/content/media-items/${avatarImageId}/download-image?width=50`;
}